import { TitleHero } from './TitleWrapper'
import { Products } from './Product'

export const Component = { TitleHero, Products }